/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

// import { User } from 'firebase/auth';
import { User } from 'firebase/auth';
import AppConfig from '../../AppConfig';
import FrontAPI from '../app/FrontAPI'; 
import _set from "lodash/set";
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';

export default class Usuario_FrontAPI extends FrontAPI
{
		public async usuarioCreateAjax(token:string,name:string|undefined,email:string,password:string,ehAdministrador:boolean) : Promise<null|IRetornoAjaxUser>
		{
			const url = AppConfig.API.usuario.create;
			const header = {"Authorization" : "Bearer "+token}
			const params = {
				displayName: name,
				email: email,
				password: password,
                ehAdministrador: ehAdministrador
			}       
			try
			{
				const res = await this.httpPost(url, params, header, undefined);
				if(res.status && (res.status == 200 || res.status == 201))
				{
					let retorno = res.data;
					retorno.status = 200;
					return retorno;
				}
				else
				{
					let retorno = res.data;
					retorno.status = 400;
					return retorno;
				}
			}
			catch(e)
			{
				return e;
			}
		}

		public async usuarioUpdateAjax(token:string,params:UserUpdateParams|{}) : Promise<any|IRetornoAjaxUser>
		{
			const url = AppConfig.API.usuario.update;
			const header = {"Authorization" : "Bearer "+token}
			try
			{
				const res = await this.httpPut(url, params, header);
				if(res.status && (res.status == 200 || res.status == 201))
				{
					let retorno = res.data;
					retorno.status = 200;
					return retorno;
				}
				else
				{
					let retorno = res.data;
					retorno.status = 400;
					return retorno;
				}
			}
			catch(e)
			{
				return e;
			}
		}

    public async usuarioDeleteAjax(token:string,uid:string) : Promise<undefined|UserRecord>
    {
        let retorno : UserRecord|undefined = undefined;
        
        const url = AppConfig.API.usuario.delete+'?uId='+uid;
        const header = {"Authorization" : "Bearer "+token}
        
        try
        {
            const res = await this.httpDelete(url, null, header);

            retorno = res.data;

            return res.data;
        }
        catch(e)
        {
            console.error(e);
        }
    }
    
    public async usuarioExpiracaoSessao(token:string) : Promise<any>
    {        
        const url = AppConfig.API.usuario.ExpiracaoUser;
        const header = {"Authorization" : "Bearer "+token}
        
        try
        {
            const res = await this.httpPost(url, {}, header, undefined);

            return res.data;
        }
        catch(e)
        {
            console.error(e);
        }
    }

    public async usuarioListaAjax(token:string,pageSize?:number,pageToken?:string,uId?:string,dataFilter?:IPropsFilterObj) : Promise<undefined|IUserlist>
    {
        const url = AppConfig.API.usuario.list;
        const header = {"Authorization" : "Bearer "+token}
        let retorno:IUserlist;
        
        try
        {
            let qs = {};

            if(pageSize)
                _set(qs, 'pageSize', pageSize);
            else if(!uId)
                _set(qs, 'pageSize', 12);
            
            if(pageToken)
                _set(qs, 'pageToken', pageToken);
            
            if(uId)
                _set(qs, 'uId', uId);

            if(dataFilter)            
                for (const indiceFilter in dataFilter)
                {
                    if (dataFilter.hasOwnProperty(indiceFilter))
                    {
                        _set(qs, indiceFilter, dataFilter[indiceFilter]);
                    }
                }   

            const res = await this.httpGet(url, header, qs, undefined);

            retorno = res.data;

            return retorno;
        }
        catch(e)
        {
            return e;
        }
    }
}

export interface IPager
{
    items_per_page: number
    pageToken: string
    total_items: number
    total_pages: number
}
export interface IUserlist
{
    Data: {
        rows: User[]
    }
    pager: IPager    
}

export interface IRetornoAjaxUser
{
    data?:
    {
        Data: User[]
        message: string
    }
    message?: string
    headers?: any
    request?: any
    status?: number
    statusText?: string
}
export interface UserRecord
{
    uid: string
    email: string
    emailVerified: boolean
    displayName: string
    disabled: boolean
    metadata: Metadata
    tokensValidAfterTime: string
    providerData: ProviderDaum[]
}

export interface UserUpdateParams
{
    uId: string
    email: string
    displayName?: string
    password?: string,
    ehAdministrador?: boolean
}

interface Metadata
{
    lastSignInTime: any
    creationTime: string
    lastRefreshTime: any
}

interface ProviderDaum 
{
    uid: string
    displayName: string
    email: string
    providerId: string
}
